export function toArray(obj) {
  return Array.isArray(obj) ? obj : [obj];
}
export default toArray;